module.exports = __webpack_public_path__ + "img/iguana-tatuada.ae8964c3.png";